import React from 'react';
import Modal from 'simple-react-modal';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { dismissModal } from '../SummerPackModal/services';
import { NNLIVE } from '../../constants/modals';
import NNLiveStore from '../../store/NNLiveStore';


const NNLiveModal = (props) => {
  const { showNNLiveModal, closeNNLiveModal, user } = props;
  const { dismissModalInSession } = NNLiveStore;
  const handleDismissForever = () => {
    if (user.authenticated) {
      dismissModalInSession();
      dismissModal({
        visible: false,
        count: 1,
        modalType: NNLIVE,
      });
    } else {
      const tenYears = moment().
        add(10, 'years').
        toDate();
      setCookie(tenYears);
    }
    closeNNLiveModal();
  };

  const handleClose = () => {
    dismissModalInSession();
    if (user.authenticated) {
      dismissModal({
        visible: true,
        count: 1,
        modalType: NNLIVE,
      });
    } else {
      const nextWeek = moment().
        add(7, 'days').
        toDate();
      setCookie(nextWeek);
    }
    closeNNLiveModal();
  };

  const setCookie = (expiry) => {
    document.cookie = `NNLIVE=hidden; expires=${expiry}`;
  };

  return (
    <Modal
      closeOnOuterClick={true}
      containerClassName="calendar-modal"
      show={showNNLiveModal}
      onClose={handleClose}
    >
      <div className={'calendar-modal-content summerpack-modal-content NNLive-modal-content'}>
        <div className="calendar-modal-text-holder">
          <h2 className="summerpack-title">Get access to NN Live now!</h2>
          <div className="summerpack-includes">Includes:</div>
          <ul className="summerpack-list NNLive-list">
            <li>Multiple LIVE shows every week</li>
            <li>A sexy selection of new guest Temptations</li>
            <li>Personal experiences including Live Chat</li>
          </ul>
        </div>
      </div>
      <div className="calendar-modal-footer">
        <Link
          className="btn btn-red"
          to="/live"
          onClick={closeNNLiveModal}
        >
          I want it!
        </Link>
        <div className="calendar-modal-dismiss" onClick={handleDismissForever}>
          I don't want to see this message again
        </div>
      </div>
      <span className="calendar-modal-close-btn" onClick={handleClose}>X</span>
    </Modal>
  );
};

export default NNLiveModal;
